/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthControllerExchangeLoginCodeMutationRequest,
  TelegramAuthControllerExchangeLoginCodeMutationResponse,
  TelegramAuthControllerExchangeLoginCode401,
  TelegramAuthControllerExchangeLoginCode403,
} from '../types/TelegramAuthControllerExchangeLoginCode.ts';

function getTelegramAuthExchangeLoginCodeUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/login-code/exchange` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/login-code/exchange}
 */
export async function telegramAuthExchangeLoginCode(
  data: TelegramAuthControllerExchangeLoginCodeMutationRequest,
  config: Partial<RequestConfig<TelegramAuthControllerExchangeLoginCodeMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthControllerExchangeLoginCodeMutationResponse,
    ResponseErrorConfig<TelegramAuthControllerExchangeLoginCode401 | TelegramAuthControllerExchangeLoginCode403>,
    TelegramAuthControllerExchangeLoginCodeMutationRequest
  >({ method: 'POST', url: getTelegramAuthExchangeLoginCodeUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
